import { generateUUID } from 'store/functions/geoJsonFunctions.js';

export const STATIC_TABLE_SETTINGS = require('store/data/table_settings_static.json');
export const INITIAL_DATA = require('store/data/input_data.json');
export const STATIC_MODEL_SETTINGS = require('store/data/model_configs.json');
export const INITIAL_GENERAL_SETTINGS = require('store/data/general_settings.json');
export const DEFAULT_TABLE_CONFIGS = require('store/data/table_configs.json');
export const DEFAULT_LOGIN_SETTINGS = require('store/data/user_templates/default_user.json');

export const INITIAL_GEO_JSON_FILTERS = {
    vehicleIds: [],
    locationLayerVisible: true,
    resultsLayerVisible: false,
    dropLayerVisible: false,
};

// data.* keys that are NOT row tables. The scenario initializer must not run
// these through the per-row table pipeline (addRowHelper etc.) — a non-array
// value would crash it — and each needs explicit re-attachment on scenario
// load (see fetchSavedScenario.fulfilled).
export const NON_TABLE_DATA_KEYS = ['resultSummary', 'resultBaseline', 'resultAmendments'];

export const DEFAULT_NOTIFICATIONS = { routine: [], optimization: [], warning: [] };
export const DEFAULT_OPTIMIZATION = { currentRuns: [], savedScenarios: [] };

export const COST_VALIDATION_EMPTY_WARNING =
    'Empty travel cost value. The value will be auto-generated during optimization using your cost configurations.';

export const DEFAULT_LOGIN_DATA = {
    ...DEFAULT_LOGIN_SETTINGS,
    loggedIn: false,
    userId: generateUUID(),
    logInSource: 'temporary',
};
